!(function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      const fontSize = 20 * (clientWidth / 1920);
      if (fontSize > 14) {
        docEl.style.fontSize = fontSize + "px";
      } else {
        docEl.style.fontSize = 14 + "px";
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/util/rem.js